import Image1 from './tastymeals.png'


const Work = [
    {
    id: 1,
    name: 'Tasty Meals' ,
    description: 'This is a web Application that does the basic booking functionalities online for home made meals in Nigeria. Built using react and Tailwind CSS.',
    image: Image1,
    link: 'https://tastmeals.netlify.app/',
    techStack: 'Next.js | Tailwind CSS | Firebase ',
    githubLink: 'https://github.com/summyalena/Tasty-Meals'
},
 
{
    id: 2,
    name: 'Conference',
    description: 'This is a website created to share awareness, created with html, css and javascript',
    image: 'http://www.google.com',
    link: 'https://www.google.com',
    techStack: 'Javascript | CSS | HTML ',
    githubLink: 'https://github.com/summyalena/'
},

{
    id: 3,
    name: 'Conference',
    description: 'This is a website created to share awareness, created with html, css and javascript',
    image: 'http://www.google.com',
    link: 'https://www.google.com',
    techStack: 'Javascript | CSS | HTML ',
    githubLink: 'https://github.com/summyalena/'
},

{
    id: 4,
    name: 'Conference',
    description: 'This is a website created to share awareness, created with html, css and javascript',
    image: 'http://www.google.com',
    link: 'https://www.google.com',
    techStack: 'Javascript | CSS | HTML ',
    githubLink: 'https://github.com/summyalena/'
},

{
    id: 5,
    name: 'Conference',
    description: 'This is a website created to share awareness, created with html, css and javascript',
    image: 'http://www.google.com',
    link: 'https://www.google.com',
    techStack: 'Javascript | CSS | HTML ',
    githubLink: 'https://github.com/summyalena/'
}
]

export default Work;
